// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"ProfileBanner__materialize-textarea___1ceQT","modal-2463794813":"ProfileBanner__modal-2463794813___3pxzT","container":"ProfileBanner__container___P_oWy","profileBannerContainer":"ProfileBanner__profileBannerContainer___2-kPI","textOnbanner":"ProfileBanner__textOnbanner___TGnvn","textOnPricingbanner":"ProfileBanner__textOnPricingbanner___22Ghq","logoContainer":"ProfileBanner__logoContainer___3PouQ","smallText":"ProfileBanner__smallText___3E0yp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileBanner/ProfileBanner.scss
// module id = 1516
// module chunks = 0